<template>
  <div>
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>日志列表</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="content_box">
      <div class="content_top" style="padding-bottom: 0;">
        <el-form :inline="true" :model="searchData" class="demo-form-inline">
          <el-form-item label="管理员">
            <el-input
              size="small"
              v-model="searchData.admin_name"
              placeholder="管理员"
              style="width: 160px; margin-right: 10px;"
            ></el-input>
          </el-form-item>
          <el-form-item label="开始时间">
            <el-date-picker
               size="small"
              value-format="yyyy-MM-dd"
              v-model="searchData.start_time"
              type="date"
              placeholder="选择日期"
              style="width: 160px; margin-right: 10px;"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="结束时间">
            <el-date-picker
              size="small"
              value-format="yyyy-MM-dd"
              v-model="searchData.end_time"
              type="date"
              placeholder="选择日期"
              style="width: 160px; margin-right: 10px;"
            ></el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button size="small" type="primary" icon="el-icon-search" @click="search">查询</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="content">
        <el-table border :data="logList">
          <el-table-column prop="admin_name" label="管理员" align="center" width="200"></el-table-column>
          <el-table-column prop="operation_ip" label="IP" align="center" width="200"></el-table-column>
          <el-table-column prop="created_at" label="操作时间" align="center" width="250"></el-table-column>
          <el-table-column prop="log_content" label="日志内容"></el-table-column>
        </el-table>
        <el-pagination
          style="margin-top: 20px"
          background
          :page-sizes="[pageSize]"
          layout="total, sizes, prev, pager, next, jumper"
          :page-size="pageSize"
          :total="total"
          @current-change="currentChange"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      page: 1,
      total: 0,
      pageSize: 8,
      logList: [],
      searchData: {
        admin_name: "",
        start_time: "",
        end_time: ""
      }
    };
  },
  methods: {
    search() {
      if (this.searchData.start_time != "" && this.searchData.end_time != "") {
        let _start_time = this.searchData.start_time.replace("-", "");
        let _end_time = this.searchData.end_time.replace("-", "");
        if (_end_time < _start_time) {
          this.$util.msg("结束时间不能小于开始时间");
          return;
        }
      }
      this.page = 1;
      this.getLogList();
    },
    currentChange(page) {
      this.page = page;
      this.getLogList();
    },
    getLogList() {
      this.$ajax({
        loading: true,
        url: "/log/index",
        data:{
          page: this.page,
          limit: this.pageSize,
          admin_name: this.searchData.admin_name,
          start_time: this.searchData.start_time,
          end_time: this.searchData.end_time
        }
      }).then(data => {
        this.logList = data.data.data;
        this.total = data.data.count;
      });
    }
  },
  mounted() {
    this.getLogList();
  }
};
</script>
<style>
</style>